import { Checkbox, Ellipsis, Radio } from '@seiue/ui'
import { FieldTypeEnum } from 'packages/sdks-next/growp'
import React from 'react'
import styled from 'styled-components'

export const LabelEllipsis: React.FC<{
  type: FieldTypeEnum
  label: string
}> = ({ type, label }) => {
  return (
    <LabelEllipsisWrapper>
      {type === FieldTypeEnum.Single ? (
        <Radio disabled />
      ) : (
        <Checkbox disabled />
      )}
      <Ellipsis text={label} />
    </LabelEllipsisWrapper>
  )
}

const LabelEllipsisWrapper = styled.div`
  width: 670px;
  display: flex;
  justify-content: flex-start;
  color: rgba(0, 0, 0, 0.25);
  &&& {
    .ant-checkbox-wrapper {
      margin-right: 8px;
    }
  }
`
